import lazyLoading from "./lazyLoading";
import CommonLayout from "../components/Layouts/Common";
import LogGuard from "./guards/log-guard";

export default [
    {
        path: "/",
        component: CommonLayout,
        beforeEnter: LogGuard,
        children: [
            {
                name: "custom.dashboard",
                path: "dashboard",
                component: lazyLoading("Dashboard/Index"),
                meta: {
                    module: "dashboard",
                },
            },
            {
                name: "custom.accept-link-account",
                path: "accept-to-link-new-account/:token",
                component: lazyLoading("Dashboard/Index"),
                meta: {
                    module: "dashboard",
                },
            },
            {
                name: "custom.issues",
                path: "issues",
                component: lazyLoading("Issues/Index"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.issues.show",
                path: "issues/:id",
                component: lazyLoading("Issues/Show"),
                meta: {
                    module: "sessions",
                }
            },
            {
                name: "custom.appointments.create",
                path: "appointments/create",
                component: lazyLoading("Nurse/Appointments/Create"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.appointments",
                path: "appointments",
                component: lazyLoading("Appointments/Index"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.appointments.show",
                path: "appointments/:id",
                component: lazyLoading("Appointments/Show"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.new_issue",
                path: "issue_appointments/:id?",
                component: lazyLoading('Issues/Schedule/Form'),
                meta: {
                    module: "appointments",
                },
            },
            {
                name: "custom.kanban.select",
                path: "kanban/select",
                component: lazyLoading("Appointments/KanbanSelector"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.kanban.board",
                path: "kanban/board/:id",
                component: lazyLoading("Appointments/KanbanBoard"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.exams",
                path: "exams",
                component: lazyLoading("Exams/Index"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.exams.create",
                path: "exams/create",
                component: lazyLoading("Exams/Create"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.exams.show",
                path: "exams/:id",
                component: lazyLoading("Exams/Show"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.examSamples",
                path: "exam-samples",
                component: lazyLoading("ExamSamples/Index"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.locations",
                path: "locations",
                component: lazyLoading("Location/Index"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.locations.create",
                path: "locations/create",
                component: lazyLoading("Location/Create"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.locations.edit",
                path: "locations/:id/edit",
                component: lazyLoading("Location/Edit"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.profile",
                path: "profile",
                component: lazyLoading("Profile"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.breeds",
                path: "breeds",
                component: lazyLoading("PetBreeds/Index"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.breeds.create",
                path: "breeds/create",
                component: lazyLoading("PetBreeds/Create"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.breeds.edit",
                path: "breeds/:id/edit",
                component: lazyLoading("PetBreeds/Edit"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.species",
                path: "species",
                component: lazyLoading("PetSpecies/Index"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.species.create",
                path: "species/create",
                component: lazyLoading("PetSpecies/Create"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.species.edit",
                path: "species/:id/edit",
                component: lazyLoading("PetSpecies/Edit"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.countries",
                path: "countries",
                component: lazyLoading("Country/Index"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.countries.create",
                path: "countries/create",
                component: lazyLoading("Country/Create"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.countries.edit",
                path: "countries/:id/edit",
                component: lazyLoading("Country/Edit"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.states",
                path: "states",
                component: lazyLoading("State/Index"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.states.create",
                path: "states/create",
                component: lazyLoading("State/Create"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.states.edit",
                path: "states/:id/edit",
                component: lazyLoading("State/Edit"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.cities",
                path: "cities",
                component: lazyLoading("City/Index"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.cities.create",
                path: "cities/create",
                component: lazyLoading("City/Create"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.cities.edit",
                path: "cities/:id/edit",
                component: lazyLoading("City/Edit"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.categories",
                path: "categories",
                component: lazyLoading("Category/Index"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.categories.create",
                path: "categories/create",
                component: lazyLoading("Category/Create"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.categories.edit",
                path: "categories/:id/edit",
                component: lazyLoading("Category/Edit"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.tax_categories",
                path: "tax_categories",
                component: lazyLoading("TaxCategory/Index"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.tax_categories.create",
                path: "tax_categories/create",
                component: lazyLoading("TaxCategory/Create"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.tax_categories.edit",
                path: "tax_categories/:id/edit",
                component: lazyLoading("TaxCategory/Edit"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.services",
                path: "services",
                component: lazyLoading("Services/Index"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.services.create",
                path: "services/create",
                component: lazyLoading("Services/Create"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.services.edit",
                path: "services/:id/edit",
                component: lazyLoading("Services/Edit"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.measurements",
                path: "measurements",
                component: lazyLoading("Measurements/Index"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.measurements.create",
                path: "measurements/create",
                component: lazyLoading("Measurements/Create"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.measurements.edit",
                path: "measurements/:id/edit",
                component: lazyLoading("Measurements/Edit"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.serviceWorkflows",
                path: "service-workflows",
                component: lazyLoading("ServiceWorkflows/Index"),
                meta: {
                    module: "workflow",
                },
            },
            {
                name: "custom.serviceWorkflows.create",
                path: "service-workflows/create",
                component: lazyLoading("ServiceWorkflows/Create"),
                meta: {
                    module: "workflow",
                },
            },
            {
                name: "custom.serviceWorkflows.edit",
                path: "service-workflows/:id/edit",
                component: lazyLoading("ServiceWorkflows/Edit"),
                meta: {
                    module: "workflow",
                },
            },
            {
                name: "custom.serviceWorkflowSections",
                path: "service-workflow-sections",
                component: lazyLoading("ServiceWorkflowSections/Index"),
                meta: {
                    module: "workflow",
                },
            },
            {
                name: "custom.serviceWorkflowSections.create",
                path: "service-workflow-sections/create",
                component: lazyLoading("ServiceWorkflowSections/Create"),
                meta: {
                    module: "workflow",
                },
            },
            {
                name: "custom.serviceWorkflowSections.edit",
                path: "service-workflow-sections/:id/edit",
                component: lazyLoading("ServiceWorkflowSections/Edit"),
                meta: {
                    module: "workflow",
                },
            },
            {
                name: "custom.employees",
                path: "employees",
                component: lazyLoading("Employees/Index"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.employees.create",
                path: "employees/create",
                component: lazyLoading("Employees/Create"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.employees.edit",
                path: "employees/:id/edit",
                component: lazyLoading("Employees/Edit"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.payslips",
                path: "employees/payslips",
                component: lazyLoading("Employees/Payslips/Index"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.payslips.create",
                path: "employees/payslips/create",
                component: lazyLoading("Employees/Payslips/Create"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.payslips.edit",
                path: "employees/payslips/:id/edit",
                component: lazyLoading("Employees/Payslips/Edit"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.customers",
                path: "customers",
                component: lazyLoading("Customers/Index"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.customers.create",
                path: "customers/create",
                component: lazyLoading("Customers/Create"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.customers.edit",
                path: "customers/:id/edit",
                component: lazyLoading("Customers/Edit"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.users",
                path: "users",
                component: lazyLoading("Users/Index"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.not_linked_users",
                path: "not_linked_users",
                component: lazyLoading("Users/NotLinkedIndex"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.share_to_accounts",
                path: "share_to_accounts",
                component: lazyLoading("Users/ShareToAccounts"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.users.create",
                path: "users/create",
                component: lazyLoading("Users/Create"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.users.edit",
                path: "users/:id/edit",
                component: lazyLoading("Users/Edit"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.reports.job",
                path: "reports/job",
                component: lazyLoading("Reports/Job"),
                meta: {
                    module: "reports",
                },
            },
            {
                name: "custom.reports.pdf",
                path: "reports/pdf",
                component: lazyLoading("Reports/Pdf"),
                meta: {
                    module: "reports",
                },
            },
            {
                name: "custom.limsReports.job",
                path: "reports/lims-job",
                component: lazyLoading("LimsReports/Job"),
                meta: {
                    module: "reports",
                },
            },
            {
                name: "custom.limsReports.pdf",
                path: "reports/lims-pdf",
                component: lazyLoading("LimsReports/Pdf"),
                meta: {
                    module: "reports",
                },
            },
            {
                name: "custom.notifications",
                path: "notifications",
                component: lazyLoading("Notifications/Index"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.notificationCampaign",
                path: "notificationCampaign",
                component: lazyLoading("NotificationCampaign/Index"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.notificationCampaign.create",
                path: "notificationCampaign/create",
                component: lazyLoading("NotificationCampaign/Create"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.notificationCampaign.edit",
                path: "notificationCampaign/:id/edit",
                component: lazyLoading("NotificationCampaign/Edit"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.user_groups",
                path: "user_groups",
                component: lazyLoading("UserGroups/Index"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.user_groups.create",
                path: "user_groups/create",
                component: lazyLoading("UserGroups/Create"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.user_groups.edit",
                path: "user_groups/:id/edit",
                component: lazyLoading("UserGroups/Edit"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.roles",
                path: "roles",
                component: lazyLoading("Roles/Index"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.roles.create",
                path: "roles/create",
                component: lazyLoading("Roles/Create"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.roles.edit",
                path: "roles/:id/edit",
                component: lazyLoading("Roles/Edit"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.permissions",
                path: "permissions",
                component: lazyLoading("Permissions/Index"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.permissions.create",
                path: "permissions/create",
                component: lazyLoading("Permissions/Create"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.permissions.edit",
                path: "permissions/:id/edit",
                component: lazyLoading("Permissions/Edit"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.xml",
                path: "xml",
                component: lazyLoading("Xml/Index"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.searchCustomers",
                path: "search-customers",
                component: lazyLoading("SearchCustomers/Index"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.searchApproveSamples",
                path: "search-approve-samples",
                component: lazyLoading("SearchApproveSamples/Index"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.examSampleScans",
                path: "exam-sample-scans",
                component: lazyLoading("ExamSampleScans/Index"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.examSampleScans.edit",
                path: "exam-sample-scans/:id/edit",
                component: lazyLoading("ExamSampleScans/Edit"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.examSampleScans.create",
                path: "exam-sample-scans/create",
                component: lazyLoading("ExamSampleScans/Create"),
                meta: {
                    module: "sessions",
                },
            },
            //Data Shares
            {
                name: "custom.myDataShares",
                path: "my-data-shares/:data_share_id/appt/:id",
                component: lazyLoading("DataShares/AppointmentShare"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.dataShares",
                path: "data-shares",
                component: lazyLoading("DataShares/Index"),
                meta: {
                    module: "sessions",
                },
            },
            // attendance
            {
                name: "custom.schedules",
                path: "schedules",
                component: lazyLoading("Attendances/Index"),
                meta: {
                    module: "attendances",
                },
            },
            {
                name: "custom.schedules.edit",
                path: "schedules/:id/edit",
                component: lazyLoading("Schedules/Edit"),
                meta: {
                    module: "dashboard",
                },
            },
            {
                name: "custom.histories",
                path: "histories",
                component: lazyLoading("Histories/Index"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.noticeHistories",
                path: "notice-histories",
                component: lazyLoading("Histories/Notices/Index"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.bank_account",
                path: "bank_accounts",
                component: lazyLoading("Finances/BankAccount/Index"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.bank_account.create",
                path: "bank_accounts/create",
                component: lazyLoading("Finances/BankAccount/Create"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.bank_account.edit",
                path: "bank_accounts/:id/edit",
                component: lazyLoading("Finances/BankAccount/Edit"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.bookkeeping",
                path: "bookkeeping",
                component: lazyLoading("Finances/Bookkeeping/Index"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.cashFlows",
                path: "cash_flows",
                component: lazyLoading("Finances/CashFlow/Index"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.cashFlows.create",
                path: "cash_flows/create",
                component: lazyLoading("Finances/CashFlow/Create"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.cashFlows.edit",
                path: "cash_flows/:id/edit",
                component: lazyLoading("Finances/CashFlow/Edit"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.mailLogs",
                path: "mail-logs",
                component: lazyLoading("Logs/MailLogs/Index"),
                meta: {
                    module: "reports",
                },
            },
            {
                name: "custom.associatedLabs",
                path: "associated-labs",
                component: lazyLoading("AssociatedLabs/Index"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.associatedLabs.create",
                path: "associated-labs/create",
                component: lazyLoading("AssociatedLabs/Create"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.associatedLabs.edit",
                path: "associated-labs/:id/edit",
                component: lazyLoading("AssociatedLabs/Edit"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.specialties",
                path: "specialties",
                component: lazyLoading("Specialties/Index"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.specialties.create",
                path: "specialties/create",
                component: lazyLoading("Specialties/Create"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.specialties.edit",
                path: "specialties/:id/edit",
                component: lazyLoading("Specialties/Edit"),
                meta: {
                    module: "menu",
                },
            },
            // LOINC
            {
                name: "custom.loinc",
                path: "exam_types",
                component: lazyLoading("Loinc/Index"),
                meta: {
                    module: "menu",
                },
            },
            // sales
            {
                name: "custom.projects",
                path: "projects",
                component: lazyLoading("Sales/Projects/Index"),
                meta: {
                    module: "sales",
                },
            },
            {
                name: "custom.projects.create",
                path: "projects/create",
                component: lazyLoading("Sales/Projects/Create"),
                meta: {
                    module: "sales",
                },
            },
            {
                name: "custom.projects.edit",
                path: "projects/:id",
                component: lazyLoading("Sales/Projects/Edit"),
                meta: {
                    module: "sales",
                },
            },
            {
                name: "custom.leads",
                path: "leads",
                component: lazyLoading("Sales/Leads/Index"),
                meta: {
                    module: "sales",
                },
            },
            {
                name: "custom.leads.create",
                path: "leads/create",
                component: lazyLoading("Sales/Leads/Create"),
                meta: {
                    module: "sales",
                },
            },
            {
                name: "custom.leads.edit",
                path: "leads/:id",
                component: lazyLoading("Sales/Leads/Edit"),
                meta: {
                    module: "sales",
                },
            },
            // end sales
            {
                name: "custom.conversations",
                path: "conversations",
                component: lazyLoading("Conversations/Index"),
                meta: {
                    module: "chats",
                },
            },
            {
                name: "custom.broadcasts",
                path: "broadcasts",
                component: lazyLoading("Broadcasts/Index"),
                meta: {
                    module: "chats",
                },
            },
            {
                name: "custom.broadcasts.create",
                path: "broadcasts/create",
                component: lazyLoading("Broadcasts/Create"),
                meta: {
                    module: "chats",
                },
            },
            {
                name: "custom.broadcasts.edit",
                path: "broadcasts/:id/edit",
                component: lazyLoading("Broadcasts/Edit"),
                meta: {
                    module: "chats",
                },
            },
            {
                name: "custom.pixAccounts",
                path: "pix-accounts",
                component: lazyLoading("Finances/PixAccounts/Index"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.pixAccounts.create",
                path: "pix-accounts/create",
                component: lazyLoading("Finances/PixAccounts/Create"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.pixAccounts.edit",
                path: "pix-accounts/:id/edit",
                component: lazyLoading("Finances/PixAccounts/Edit"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.pixHistories",
                path: "pix-histories",
                component: lazyLoading("Finances/PixHistories/Index"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.accountsReceivable",
                path: "accounts-receivable",
                component: lazyLoading(
                    "Finances/AccountsReceivable/Index"
                ),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.accountsReceivable.edit",
                path: "accounts-receivable/:id/edit",
                component: lazyLoading(
                    "Finances/AccountsReceivable/Edit"
                ),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.accountsPayable",
                path: "accounts-payable",
                component: lazyLoading("Finances/AccountsPayable/Index"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.payments",
                path: "payments",
                component: lazyLoading("Finances/Payment/Index"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.payments.detail",
                path: "payments/:id",
                component: lazyLoading("Finances/Payment/Detail"),
                meta: {
                    module: "finances",
                },
            },
            {
                name: "custom.importCustomers",
                path: "import-customers",
                component: lazyLoading("ImportCustomers/Index"),
                meta: {
                    module: "logins",
                },
            },
            {
                name: "custom.importXmlTemplates",
                path: "import-xml-templates",
                component: lazyLoading("ImportXMLTemplates/Index"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.importXmlTemplates.create",
                path: "import-xml-templates/create",
                component: lazyLoading("ImportXMLTemplates/Create"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.importXmlTemplates.edit",
                path: "import-xml-templates/:id/edit",
                component: lazyLoading("ImportXMLTemplates/Edit"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.importXml",
                path: "import-xml",
                component: lazyLoading("ImportXml/Index"),
                meta: {
                    module: "sessions",
                },
            },
            {
                name: "custom.exportXml",
                path: "export-xml",
                component: lazyLoading("ExportXml/Index"),
                meta: {
                    module: "sessions",
                },
            },
            // medico
            {
                name: "custom.medico.employeePrescriptionSchedules",
                path: "medical/prescription-schedules",
                component: lazyLoading("Medico/EmployeePrescriptionSchedules/Index"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.medico.employeePrescriptionSchedules.create",
                path: "medical/prescription-schedules/create",
                component: lazyLoading("Medico/EmployeePrescriptionSchedules/Create"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.medico.employeePrescriptionSchedules.show",
                path: "medical/prescription-schedules/:id",
                component: lazyLoading("Medico/EmployeePrescriptionSchedules/Edit"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.medico.medications",
                path: "medical/medications",
                component: lazyLoading("Medico/Medications/Index"),
                meta: {
                    module: "medico",
                },
            },
            // medico insurance
            {
                name: "custom.medico.insurances",
                path: "medico/insurances",
                component: lazyLoading("Medico/Insurances/Index"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.medico.insurances.create",
                path: "medico/insurances/create",
                component: lazyLoading("Medico/Insurances/Create"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.medico.insurances.edit",
                path: "medico/insurances/:id/edit",
                component: lazyLoading("Medico/Insurances/Edit"),
                meta: {
                    module: "medico",
                },
            },
            // medico insurance plans
            {
                name: "custom.medico.insurance.plans",
                path: "medico/insurance/plans",
                component: lazyLoading("Medico/InsurancePlans/Index"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.medico.insurance.plans.create",
                path: "medico/insurance/plans/create",
                component: lazyLoading("Medico/InsurancePlans/Create"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.medico.insurance.plans.edit",
                path: "medico/insurance/plans/:id/edit",
                component: lazyLoading("Medico/InsurancePlans/Edit"),
                meta: {
                    module: "medico",
                },
            },
            // medico charting by exceptions
            {
                name: "custom.medico.chartingByExceptions",
                path: "medical/charting_by_exceptions",
                component: lazyLoading("Medico/ChartingByExceptions/Index"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.medico.chartingByExceptions.create",
                path: "medical/charting_by_exceptions/create",
                component: lazyLoading("Medico/ChartingByExceptions/Create"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.medico.chartingByExceptions.edit",
                path: "medical/charting_by_exceptions/:id/edit",
                component: lazyLoading("Medico/ChartingByExceptions/Edit"),
                meta: {
                    module: "medico",
                },
            },
            // medico procedures
            {
                name: "custom.medico.procedures",
                path: "medical/procedures",
                component: lazyLoading("Medico/Procedures/Index"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.medico.procedures.create",
                path: "medical/procedures/create",
                component: lazyLoading("Medico/Procedures/Create"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.medico.procedures.edit",
                path: "medical/procedures/:id/edit",
                component: lazyLoading("Medico/Procedures/Edit"),
                meta: {
                    module: "medico",
                },
            },
            // ICD
            {
                name: "custom.medico.icd.index",
                path: "medical/icd/index",
                component: lazyLoading("Medico/ICD/Index"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.medico.icd.search",
                path: "medical/icd/search",
                component: lazyLoading("Medico/ICD/Search"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.medico.icd.create",
                path: "medical/procedures/create",
                component: lazyLoading("Medico/ICD/Create"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.medico.icd.edit",
                path: "medical/icd/:id/edit",
                component: lazyLoading("Medico/ICD/Edit"),
                meta: {
                    module: "medico",
                },
            },
            // Medical record
            {
                name: "custom.medico.record.edit",
                path: "medical/record/:appointment_id",
                component: lazyLoading("Medico/MedicalRecord/Form"),
                meta: {
                    module: "medico",
                },
            },
            {
                name: "custom.settings.categories",
                path: "medical/form_categories",
                component: lazyLoading("Medico/FormCategories/Index"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.settings.categories.create",
                path: "medical/form_categories/create",
                component: lazyLoading("Medico/FormCategories/Create"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.settings.categories.edit",
                path: "medical/form_categories/:id/edit",
                component: lazyLoading("Medico/FormCategories/Edit"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.settings.items",
                path: "medical/form_items",
                component: lazyLoading("Medico/FormItems/Index"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.settings.items.create",
                path: "medical/form_items/create",
                component: lazyLoading("Medico/FormItems/Create"),
                meta: {
                    module: "settings",
                },
            },
            {
                name: "custom.settings.items.edit",
                path: "medical/form_items/:id/edit",
                component: lazyLoading("Medico/FormItems/Edit"),
                meta: {
                    module: "settings",
                },
            },
            // supply chain item categories
            {
                name: "custom.brands",
                path: "brands",
                component: lazyLoading("SupplyChain/Brands/Index"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.brands.edit",
                path: "brands/:id/edit",
                component: lazyLoading("SupplyChain/Brands/Edit"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.brands.create",
                path: "brands/create",
                component: lazyLoading("SupplyChain/Brands/Create"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.manufacturers",
                path: "vendors",
                component: lazyLoading(
                    "SupplyChain/Manufacturers/Index"
                ),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.manufacturers.edit",
                path: "vendors/:id/edit",
                component: lazyLoading("SupplyChain/Manufacturers/Edit"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.manufacturers.create",
                path: "vendors/create",
                component: lazyLoading(
                    "SupplyChain/Manufacturers/Create"
                ),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.categories",
                path: "supply-chain/categories",
                component: lazyLoading("SupplyChain/Categories/Index"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.categories.create",
                path: "supply-chain/categories/create",
                component: lazyLoading("SupplyChain/Categories/Create"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.categories.edit",
                path: "supply-chain/categories/:id/edit",
                component: lazyLoading("SupplyChain/Categories/Edit"),
                meta: {
                    module: "supply_chain",
                },
            },
            // financial categories
            {
                name: "custom.supplyChains.accountingCategories",
                path: "supply-chain/accounting-categories",
                component: lazyLoading(
                    "SupplyChain/AccountingCategories/Index"
                ),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.accountingCategories.create",
                path: "supply-chain/accounting-categories/create",
                component: lazyLoading(
                    "SupplyChain/AccountingCategories/Create"
                ),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.accountingCategories.edit",
                path: "supply-chain/accounting-categories/:id/edit",
                component: lazyLoading(
                    "SupplyChain/AccountingCategories/Edit"
                ),
                meta: {
                    module: "supply_chain",
                },
            },
            // supply chain raw items
            {
                name: "custom.supplyChains.rawItems",
                path: "supply-chain/raw-items",
                component: lazyLoading("SupplyChain/RawItem/Index"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.rawItems.create",
                path: "supply-chain/raw-items/create",
                component: lazyLoading("SupplyChain/RawItem/Create"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.rawItems.edit",
                path: "supply-chain/raw-items/:id/edit",
                component: lazyLoading("SupplyChain/RawItem/Edit"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.purchaseOrders",
                path: "supply-chain/purchase-orders",
                component: lazyLoading(
                    "SupplyChain/PurchaseOrders/Index"
                ),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.purchaseOrders.create",
                path: "supply-chain/purchase-orders/create",
                component: lazyLoading(
                    "SupplyChain/PurchaseOrders/Create"
                ),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.purchaseOrders.edit",
                path: "supply-chain/purchase-orders/:id/edit",
                component: lazyLoading(
                    "SupplyChain/PurchaseOrders/Edit"
                ),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.poInvoices",
                path: "supply-chain/po-invoices",
                component: lazyLoading("SupplyChain/PoInvoices/Index"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.reconcilePo",
                path: "supply-chain/reconcile-po",
                component: lazyLoading("SupplyChain/Reconciles/Index"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.itemStocks",
                path: "supply-chain/item-stocks",
                component: lazyLoading("SupplyChain/ItemStocks/Index"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.stockMovements",
                path: "supply-chain/stock-movements",
                component: lazyLoading(
                    "SupplyChain/StockMovements/Index"
                ),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.itemFusions",
                path: "supply-chain/item-fusions",
                component: lazyLoading("SupplyChain/ItemFusions/Index"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.itemFusions.create",
                path: "supply-chain/item-fusions/create",
                component: lazyLoading("SupplyChain/ItemFusions/Create"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.supplyChains.itemFusions.edit",
                path: "supply-chain/item-fusions/:id/edit",
                component: lazyLoading("SupplyChain/ItemFusions/Edit"),
                meta: {
                    module: "supply_chain",
                },
            },
            {
                name: "custom.create_room",
                path: "virtual/room",
                component: lazyLoading("VirtualRoom/Index"),
                meta: {
                    module: "virtual",
                },
            },
            {
                name: "custom.legal.categories",
                path: "legal/categories",
                component: lazyLoading("Legal/Categories/Index"),
                meta: {
                    module: "legal",
                },
            },
            {
                name: "custom.legal.categories.create",
                path: "legal/categories/create",
                component: lazyLoading("Legal/Categories/Create"),
                meta: {
                    module: "legal",
                },
            },
            {
                name: "custom.legal.categories.edit",
                path: "legal/categories/:id/edit",
                component: lazyLoading("Legal/Categories/Edit"),
                meta: {
                    module: "legal",
                },
            },
            {
                name: "custom.legal.rawItems",
                path: "legal/items",
                component: lazyLoading("Legal/RawItem/Index"),
                meta: {
                    module: "legal",
                },
            },
            {
                name: "custom.legal.rawItems.create",
                path: "legal/items/create",
                component: lazyLoading("Legal/RawItem/Create"),
                meta: {
                    module: "legal",
                },
            },
            {
                name: "custom.legal.rawItems.edit",
                path: "legal/items/:id/edit",
                component: lazyLoading("Legal/RawItem/Edit"),
                meta: {
                    module: "legal",
                },
            },
            {
                name: "custom.publicServiceDescriptions",
                path: "service-descriptions",
                component: lazyLoading("PublicServiceDescription/Index"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.publicServiceDescriptions.create",
                path: "service-descriptions/create",
                component: lazyLoading(
                    "PublicServiceDescription/Create"
                ),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.publicServiceDescriptions.edit",
                path: "service-descriptions/:id/edit",
                component: lazyLoading("PublicServiceDescription/Edit"),
                meta: {
                    module: "menu",
                },
            },
            {
                name: "custom.quality.specifications",
                path: "quality/specifications",
                component: lazyLoading("Quality/Specifications/Index"),
                meta: {
                    module: "quality",
                },
            },
            {
                name: "custom.quality.specifications.create",
                path: "quality/specifications/create",
                component: lazyLoading("Quality/Specifications/Create"),
                meta: {
                    module: "quality",
                },
            },
            {
                name: "custom.quality.specifications.edit",
                path: "quality/specifications/:id/edit",
                component: lazyLoading("Quality/Specifications/Edit"),
                meta: {
                    module: "quality",
                },
            },
        ],
    },
];
